import { MusicInfo } from '@shared/types';

export const parseMusicians = (musicians?: MusicInfo[]) =>
  musicians ? musicians.map((musician: MusicInfo) => musician.title)?.join(', ') : '';
